export default "__VITE_ASSET__pZzLVuqL__"